"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputCep = void 0;
exports.isCepBasicoValido = isCepBasicoValido;
var react_1 = __importStar(require("react"));
var Cores_1 = require("../../Cores/Cores");
var Icone_1 = require("../../Icone/Icone");
var HelperText_1 = require("../../HelperText/HelperText");
var Label_1 = require("../../Label/Label");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var estiloInputCep = require("./InputCEP.module.scss");
//#endregion
//#region Máscara CEP
var MASCARA_CEP = "#####-###";
var somenteNumeros = function (value) { return value.replace(/\D/g, ""); };
var aplicarMascaraCep = function (valor) {
    var i = 0;
    var v = somenteNumeros(valor);
    return MASCARA_CEP.replace(/#/g, function () { var _a; return (_a = v[i++]) !== null && _a !== void 0 ? _a : ""; });
};
function calcularNovaPosicao(beforeRaw, afterMask, cursor) {
    var digitsBefore = beforeRaw
        .slice(0, cursor)
        .replace(/\D/g, "").length;
    var pos = 0;
    var digitCount = 0;
    while (pos < afterMask.length && digitCount < digitsBefore) {
        if (/\d/.test(afterMask[pos]))
            digitCount++;
        pos++;
    }
    return pos;
}
//#endregion
//#region Validação Básica CEP
var CEP_INVALIDOS = new Set([
    "00000000",
    "11111111",
    "22222222",
    "33333333",
    "44444444",
    "55555555",
    "66666666",
    "77777777",
    "88888888",
    "99999999",
]);
function isCepBasicoValido(cep) {
    var digits = cep.replace(/\D/g, "");
    if (digits.length !== 8)
        return false;
    return !CEP_INVALIDOS.has(digits);
}
//#endregion
//#region Componente
var InputCep = function (props) {
    //#region States
    var _a = (0, react_1.useState)(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600), cor = _a[0], setCor = _a[1];
    var _b = (0, react_1.useState)(props.value || ""), inputValue = _b[0], setInputValue = _b[1];
    var _c = (0, react_1.useState)(props.variante || "regular"), varianteState = _c[0], setVarianteState = _c[1];
    var _d = (0, react_1.useState)(props.tamanho === "small" ? "16px" : "20px"), iconeSize = _d[0], setIconeSize = _d[1];
    var _e = (0, react_1.useState)(props.conteudoAjuda || undefined), conteudoAjudaState = _e[0], setConteudoAjudaState = _e[1];
    //#endregion
    //#region Variaveis
    var inputFieldSize = estiloInputCep[props.tamanho || "medium"] || "";
    var disabledStyle = estiloInputCep.disabled || "";
    var estiloVariacao = estiloInputCep[varianteState] || estiloInputCep["regular"];
    var inputfieldStyle = props.desabilitado ? disabledStyle : estiloVariacao;
    //#endregion
    //#region Handlers
    var handleChange = function (event) {
        var _a, _b;
        if (props.readOnly || props.desabilitado)
            return;
        var entrada = event.target;
        var cursorAntes = (_a = entrada.selectionStart) !== null && _a !== void 0 ? _a : 0;
        var valorBrutoAntes = entrada.value;
        var mascarado = aplicarMascaraCep(valorBrutoAntes);
        var novaPosicao = calcularNovaPosicao(valorBrutoAntes, mascarado, cursorAntes);
        if (mascarado !== inputValue) {
            setInputValue(mascarado);
            (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, mascarado);
        }
        requestAnimationFrame(function () {
            entrada.setSelectionRange(novaPosicao, novaPosicao);
        });
    };
    var handleFocus = function (event) {
        var _a;
        (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, event);
    };
    var handleBlur = function (event) {
        var _a;
        var valor;
        if (event.target.value === "-" || event.target.value === "") {
            valor = "";
            setConteudoAjudaState(undefined);
            setVarianteState("regular");
        }
        else {
            if (props.validacaoAvancada) {
                var cepValido = props.validacaoAvancada(event.target.value);
                if (!cepValido) {
                    setConteudoAjudaState({
                        texto: "CEP inválido.",
                        icone: "warning",
                        estado: "error",
                    });
                    setVarianteState("error");
                }
                else {
                    setConteudoAjudaState(undefined);
                    setVarianteState("regular");
                }
            }
            if (props.validacaoBasica) {
                if (!isCepBasicoValido(event.target.value)) {
                    setConteudoAjudaState({
                        texto: "CEP inválido.",
                        icone: "warning",
                        estado: "error",
                    });
                    setVarianteState("error");
                }
                else {
                    setConteudoAjudaState(undefined);
                    setVarianteState("regular");
                }
            }
            valor = aplicarMascaraCep(event.target.value);
        }
        setInputValue(valor);
        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, event);
    };
    var limparCampo = function () {
        var _a;
        setInputValue("");
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, "");
    };
    //#endregion
    //#region Componentes Internos
    var label = props.textoLabel !== null
        ? typeof props.textoLabel === "object"
            ? props.textoLabel
            : typeof props.textoLabel === "string" && react_1.default.createElement(Label_1.Label, { texto: props.textoLabel })
        : null;
    var botaoLimpar = props.botaoDeLimpar
        && !globalMu_1.default.isNullOrEmpty(inputValue)
        && !props.desabilitado
        && !props.readOnly
        && (react_1.default.createElement("div", { onClick: limparCampo, className: "\n                ".concat(estiloInputCep.botaoLimpar, " \n                ").concat(inputFieldSize, " \n                ").concat(props.desabilitado ? disabledStyle : "", "\n            ") },
            react_1.default.createElement(Icone_1.Icone, { nome: "close", largura: iconeSize, altura: iconeSize, desabilitado: props.desabilitado, cor: cor, corOnHover: Cores_1.Cores.MensagensDoSistema.VermelhoMU })));
    var conteudoDeAjuda = conteudoAjudaState && (react_1.default.createElement(HelperText_1.HelperText, __assign({}, conteudoAjudaState, { key: "helper-text-input-cep-".concat(props.id || "sem-id"), estado: varianteState, desabilitado: props.desabilitado })));
    var inputEntrada = (react_1.default.createElement("input", { type: "text", id: props.id, value: inputValue, placeholder: props.placeholder, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, disabled: props.desabilitado, readOnly: props.readOnly }));
    //#endregion
    //#region UseEffects
    (0, react_1.useEffect)(function () {
        if (props.value === undefined)
            return;
        setInputValue(props.value);
    }, [props.value]);
    (0, react_1.useEffect)(function () {
        setIconeSize(props.tamanho === "small" ? "16px" : "20px");
    }, [props.tamanho]);
    (0, react_1.useEffect)(function () {
        if (props.desabilitado) {
            setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU400);
        }
        else if (props.conteudoAjuda === undefined) {
            setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600);
        }
        else {
            switch (props.variante) {
                case "success":
                    setCor(Cores_1.Cores.MensagensDoSistema.VerdeMU);
                    break;
                case "error":
                    setCor(Cores_1.Cores.MensagensDoSistema.VermelhoMU);
                    break;
                case "regular":
                    setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600);
                    break;
                default:
                    setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600);
                    break;
            }
        }
    }, [props.variante, props.desabilitado, props.conteudoAjuda]);
    (0, react_1.useEffect)(function () {
        setVarianteState(props.variante || "regular");
    }, [props.variante]);
    (0, react_1.useEffect)(function () {
        var _a;
        setConteudoAjudaState(props.conteudoAjuda || undefined);
        setVarianteState(((_a = props.conteudoAjuda) === null || _a === void 0 ? void 0 : _a.estado) || "regular");
    }, [props.conteudoAjuda]);
    //#endregion
    //#region Render
    return (react_1.default.createElement("div", { className: estiloInputCep.container, style: __assign(__assign({}, props.style), { gap: "".concat(conteudoAjudaState ? "8px" : "0px") }) },
        react_1.default.createElement("div", { className: estiloInputCep.conteudo },
            label,
            react_1.default.createElement("div", { className: "\n                        ".concat(estiloInputCep.input, " \n                        ").concat(inputFieldSize, " \n                        ").concat(inputfieldStyle, "\n                    ") },
                inputEntrada,
                botaoLimpar)),
        conteudoDeAjuda));
    //#endregion
};
exports.InputCep = InputCep;
